<template lang="pug">
  .contenedor-interno
    .title
      span Mis solicitudes de permisos
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close
    .show-closed-text(v-if="!isEditing")
      span(
        @click="showClosed = !showClosed"
      )
        template(v-if="showClosed") Mostrando todas las solicitudes
        template(v-else) Mostrando solo las solicitudes abiertas
    transition(name="fade")
      div.position-relative(
        v-if="!isEditing"
        key="list-solicitudes"
      )
        transition(
          name='fade-quick'
          v-if="isMostrandoAdjuntar"
          )
          .overlay-class(ref="adjuntarSolicitud")
            upload-image(
              name="adjuntar_solicitud_permiso",
              folder="permiso",
              :is-saved="isSavedAdjunto"
              @close="closeAdjuntar"
              @save="guardarAdjunto"
            )
              span(slot="explanation") Adjunta la imagen que sustenta tu permiso
        transition(
          name='fade',
          tag="div",
          v-if="mostrarConfirmacionEnviar"
          )
          confirmar-accion-overlay(
            @close="mostrarConfirmacionEnviar = false"
            @do="enviarJefe"
            ref="confirmarEnviar"
          )
            span(slot="title") ¿Desea enviar la solicitud?
            span(slot="primaryAction")
              template(v-if="isSending")
                | Enviando...
              template(v-else)
                | Enviar
          span Luego de enviar la notificación a su jefe, no podrá modificarlo
        transition(
          name='fade',
          tag="div",
          v-if="mostrarConfirmacionRechazar"
          )
          confirmar-accion-overlay(
            @close="mostrarConfirmacionRechazar = false"
            @do="rechazar"
            ref="confirmarRechazar"
          )
            span(slot="title") ¿Desea rechazar la solicitud?
            span(slot="primaryAction")
              template(v-if="isSending")
                | Rechazando...
              template(v-else)
                | Rechazar
        .is-desktop
          loading(v-if="isLoading")
          table.table.is-striped.is-bordered(v-else)
            thead
              th Tipo
              th Motivo
              th Estado
              //- th Adjunto
              th Acciones
            tbody(
              name="table-row"
              is="transition-group"
            )
              tr.row-table(
                v-for="(o, index) in solicitudes"
                v-if="showClosed || (!showClosed && o.estadoData.abierto)"
                :key="index"
                :class="{'is-close': !o.estadoData.abierto}"
              )
                td
                  span.hint--top(:aria-label="'Solicitud: ' + o.id") {{ o.descripcionTipo }}
                  //- strong {{ o.id }}
                  //- template &nbsp;- {{ o.descripcionTipo }}
                td
                  template(v-if="o.motivo")
                    span {{ o.motivo }}
                  template(v-else)
                    span Sin motivo
                  br
                  .dias-pedidos
                    strong Dias pedidos
                    div(v-for="i in o.detalle")
                      span.detalle-dias {{ i.desde === i.hasta ? i.desde : `${i.desde} - ${i.hasta}` }}   {{ i.horaDesde }}-{{ i.horaHasta }}
                td {{ o.estadoData.descripcion }}
                td.text-center
                  template(v-if="o.adjunto")
                    a.button.is-small(:href="o.adjunto", target="_blank")
                      span.icon.is-small
                        i.fa.fa-paperclip.is-small.fs-12
                      span Ver adjunto
                  template(v-else)
                    button.button.is-small(@click="abrirAdjuntar(o)")
                      span.icon.is-small
                        i.fa.fa-upload.fs-12
                      span Adjuntar
                  .contenedor-acciones(v-if="o.estado === 1")
                    button.button.is-small(@click="enterEditMode(o)")
                      span.icon.is-small
                        i.fa.fa-pencil-square-o
                      span Editar
                    button.button.is-small(@click="confirmarEnviar(o)")
                      span.icon.is-small
                        i.fa.fa-paper-plane-o
                      span Enviar
                    button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                      span.icon.is-small
                        i.fa.fa-times
                      span Rechazar
                  .contenedor-acciones(v-else-if="o.estado === 2")
                    button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                      span.icon.is-small
                        i.fa.fa-times
                      span Rechazar
                  .contenedor-acciones(v-else-if="o.estado === 3")
                    span No hay acciones
                  .contenedor-acciones(v-else)
                    span No hay acciones

        .is-mobile
          loading(v-if="isLoading")
          .box(
            v-for="(o, index) in solicitudes"
            v-if="showClosed || (!showClosed && o.estadoData.abierto)"
            :key="index"
          )
            .status
              span {{ o.estadoData.descripcion }}
            .descripcion-tipo.hint--top(:aria-label="'Solicitud: ' + o.id")
              span {{ o.descripcionTipo }}
            .motivo
              div(v-for="m in o.motivoLista")
                span {{ m }}
            .dias-pedidos
              strong Dias pedidos
              div(v-for="i in o.detalle")
                span.detalle-dias {{ i.desde === i.hasta ? i.desde : `${i.desde} - ${i.hasta}` }}   {{ i.horaDesde }}-{{ i.horaHasta }}
            .botones
              template(v-if="o.adjunto")
                a.button.is-small(:href="o.adjunto", target="_blank")
                  span.icon.is-small
                        i.fa.fa-paperclip.is-small.fs-12
                  span Ver adjunto
              template(v-else)
                button.button.is-small(@click="abrirAdjuntar(o)")
                  span.icon.is-small
                    i.fa.fa-upload.fs-12
                  span Adjuntar
              template(v-if="o.estado === 1")
                button.button.is-small(@click="enterEditMode(o)")
                  span.icon.is-small
                    i.fa.fa-pencil-square-o
                  span Editar
                button.button.is-small(@click="confirmarEnviar(o)")
                  span.icon.is-small
                    i.fa.fa-paper-plane-o
                  span Enviar
                button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                  span.icon.is-small
                    i.fa.fa-times
                  span Rechazar
              template(v-else-if="o.estado === 2")
                button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                  span.icon.is-small
                    i.fa.fa-times
                  span Rechazar
      div(
        key="edit-solicitud"
        v-else
      )
        nueva-solicitud(
          :is-editing="true"
          :solicitud="solicitudSeleccionada"
          @close="isEditing = false"
          @closeRefresh="isEditing = false; fetch();"
          ref="editarSolicitud"
        )
</template>

<script>
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import { scrollTo } from '../util/scroll'
import SolicitudPermisosComponent from './Component_Permisos_Solicitud'
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'
import UploadImageComponent from './Component_Upload_Image'
export default {
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'nueva-solicitud': SolicitudPermisosComponent,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent,
    'upload-image': UploadImageComponent
  },
  data () {
    return {
      solicitudes: [],
      solicitudSeleccionada: {},
      showClosed: false,
      isEditing: false,
      mostrarConfirmacionEnviar: false,
      mostrarConfirmacionRechazar: false,
      isLoading:true,
      isMostrandoAdjuntar: false,
      isSavedAdjunto: false,
      screenWidth: window.innerWidth,
      isSending: false
    }
  },
  created () {
    this.fetch()
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    });
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    });
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/permisos/empleado/solicitud', obj, function (data) {
        for (let i = 0; i < data.lista.length; i++) {
          data.lista[i].motivoLista = data.lista[i].motivo.split('\n');
        }
        vm.solicitudes = data.lista
        if (vm.solicitudes.length === 0) vm.$emit('close')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    enterEditMode (o) {
      this.solicitudSeleccionada = o
      this.isEditing             = true
      this.$nextTick(() => {
        scrollTo({
          vm:this,
          ref:this.$refs.editarSolicitud.$el,
          mobile: -20,
          desktop: -60,
          hasPermisoSolicitud: true
        });
      })
      // scrollTo({vm:this, mobile: -70, desktop: -40, ref: this.$refs.editarSolicitud})
    },
    confirmarEnviar (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionEnviar = true
      this.$nextTick(() => {
        scrollTo({
          vm:this,
          ref:this.$refs.confirmarEnviar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      })
    },
    confirmarRechazo (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionRechazar = true
      this.$nextTick(() => {
        scrollTo({
          vm:this,
          ref:this.$refs.confirmarRechazar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      })
    },
    enviarJefe () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        id: vm.solicitudSeleccionada.id
      }
      apiPost(vm, '/permisos/solicitud/send', obj, function (data) {
        vm.mostrarConfirmacionEnviar = false
        vm.fetch()
      }, function (error) {
        alert('error:' + error.message)
      }, function () {
        vm.isSending = false
      })
    },
    rechazar () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        id: this.solicitudSeleccionada.id,
        isMisSolictudes: true
      }
      apiDelete(vm, '/permisos/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
      })
    },
    abrirAdjuntar (o) {
      this.solicitudSeleccionada = o
      this.isMostrandoAdjuntar   = true
      this.$nextTick(() => {
        scrollTo({
          vm:this,
          ref:this.$refs.adjuntarSolicitud,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      })
    },
    guardarAdjunto (fileSubido) {
      var vm = this
      var obj = {
        id: this.solicitudSeleccionada.id,
        fileSubido: fileSubido
      }

      apiPost(vm, '/permisos/solicitud/adjuntar', obj, function (data) {
        vm.fetch()
        vm.closeAdjuntar()
        notify(vm, 'success', 'Éxito', 'Adjuntado correctamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    closeAdjuntar () {
      this.solicitudSeleccionada = {}
      this.isMostrandoAdjuntar   = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      cursor pointer
      i
        font-size 16px

    .title
      padding-left: 10px
      padding-right: 10px
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  .contenedor-acciones
    padding-top 4px
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px
      // i
      //   margin-left 2px
      //   font-size 15px

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important

  th
    text-align center

  td
    vertical-align: middle;

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .show-closed-text
    cursor pointer
    color #12537e
    padding-bottom 10px


  .dias-pedidos
    font-size 12px
    color #9a9a9a

  .fs-12
    font-size 12px

  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px

  @media (max-width 578px)
    .is-mobile
      display block

    .is-desktop
      display none

</style>



// WEBPACK FOOTER //
// Component_Permisos_Lista_Solicitud.vue?3a77c831